/**
 * TRH Sample Quantity Guard (2026-11-02)
 * ============================================================================
 * Rule: a sample (shared "Sample Swatch" line for one product + colorway, or a
 * per-product Format = Sample variant such as Fortuny) can only be in the cart
 * once, at quantity 1.
 *
 * The cart page and cart drawer show "Qty 1" with no +/- for sample lines.
 * This script covers everything else that can put a sample in the cart at a
 * higher quantity (back button, cart permalinks like /cart/<id>:8, carts
 * created before this change, other add-to-cart code). On every page load, on
 * back/forward cache restores, and after theme cart updates it reads
 * /cart.js and:
 *   - sets any sample line with quantity > 1 back to 1 (/cart/change.js)
 *   - removes extra lines of the same sample (keeps the first)
 * then refreshes the cart page / drawer / cart bubble.
 *
 * Limitation: theme code cannot block checkout itself. A checkout started
 * outside the theme (Shop Pay / direct checkout link) is not checked here.
 */
(function () {
  'use strict';

  var LOG_PREFIX = '[TRHSampleQtyGuard]';
  var SHARED_SAMPLE_HANDLE = 'trh-sample-swatch';
  var SHARED_SAMPLE_SKU = 'TRH-SAMPLE';
  var running = false;

  function isSampleLine(item) {
    if (item.properties && item.properties._sample_of) return true;
    if (item.handle === SHARED_SAMPLE_HANDLE || item.sku === SHARED_SAMPLE_SKU) return true;
    var opts = item.options_with_values || [];
    for (var i = 0; i < opts.length; i++) {
      if (opts[i].name === 'Format' && opts[i].value === 'Sample') return true;
    }
    return false;
  }

  /* One sample = one product + colorway. A per-product Sample variant is its
   * own key; shared Sample Swatch lines are keyed by the parent they sample. */
  function sampleKey(item) {
    var isShared = item.handle === SHARED_SAMPLE_HANDLE || item.sku === SHARED_SAMPLE_SKU;
    if (!isShared) return 'v:' + item.variant_id;
    var parent = item.properties && item.properties._sample_of;
    return parent ? 'p:' + parent : 'k:' + item.key;
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/change HTTP ' + r.status);
      return r.json();
    });
  }

  function refreshUi() {
    if (/^\/cart\/?$/.test(window.location.pathname)) {
      /* Reload at most once every 10 s so a failed change can never loop. */
      var last = Number(sessionStorage.getItem('trhSampleGuardReload') || 0);
      if (Date.now() - last > 10000) {
        sessionStorage.setItem('trhSampleGuardReload', String(Date.now()));
        window.location.reload();
      }
      return;
    }
    fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        function inner(html, selector) {
          var doc = new DOMParser().parseFromString(html || '', 'text/html');
          var el = doc.querySelector(selector);
          return el ? el.innerHTML : null;
        }
        var drawer = document.getElementById('CartDrawer');
        var drawerHtml = inner(sections['cart-drawer'], '#CartDrawer');
        if (drawer && drawerHtml !== null) drawer.innerHTML = drawerHtml;
        var bubble = document.getElementById('cart-icon-bubble');
        var bubbleHtml = inner(sections['cart-icon-bubble'], '.shopify-section');
        if (bubble && bubbleHtml !== null) bubble.innerHTML = bubbleHtml;
      })
      .catch(function (err) { console.warn(LOG_PREFIX, 'UI refresh failed (non-fatal):', err); });
  }

  function enforce() {
    if (running) return;
    running = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var seen = {};
        var fixes = [];
        (cart.items || []).forEach(function (item) {
          if (!isSampleLine(item)) return;
          var k = sampleKey(item);
          if (seen[k]) {
            fixes.push({ key: item.key, quantity: 0 });
          } else {
            seen[k] = true;
            if (item.quantity > 1) fixes.push({ key: item.key, quantity: 1 });
          }
        });
        if (!fixes.length) return false;
        console.log(LOG_PREFIX, 'Limiting sample lines to 1:', fixes);
        return fixes.reduce(function (p, fix) {
          return p.then(function () { return changeLine(fix.key, fix.quantity); });
        }, Promise.resolve()).then(function () { return true; });
      })
      .then(function (changed) {
        running = false;
        if (changed) refreshUi();
      })
      .catch(function (err) {
        running = false;
        console.warn(LOG_PREFIX, err);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforce);
  } else {
    enforce();
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) enforce(); });

  /* Theme pub/sub (assets/pubsub.js): re-check after any theme cart update. */
  /* global PUB_SUB_EVENTS, subscribe */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(enforce, 300); });
  }
})();
